export const projects = [
  {
    title: "A Study of Morris Worm in Sandbox Environment",
    description:
      "A comprehensive analysis of the Morris Worm, one of the earliest computer worms, conducted within a controlled sandbox environment to understand its propagation mechanisms and impact on network security.",
    features: [
      "Sandbox environment setup for safe analysis",
      "Detailed examination of the worm's code and behavior",
      "Insights into the worm's impact on network security and mitigation strategies",
    ],
    tech: ["Unix", "Python", "C", "Docker", "Simh", "React"],
    links: {
      demo: "https://comps-pied-alpha.vercel.app/",
      github: "https://github.com/Lee-Li-404/Winter2026Comps",
    },
  },
  {
    title: "The Living Funeral",
    description:
      "An interactive, web-based extension of a physical art installation that uses AI to provoke deep reflection on themes of life, death, and self-reflection.\n",
    features: [
      "Reflective narrative guided by participant inputs",
      "Customized AI-generated eulogy",
      "ChatGPT & ElevenLabs API integration",
    ],
    tech: [
      "React",
      "Next.js",
      "JavaScript",
      "GPT-4 API",
      "Text-to-Speech API",
      "Vercel",
      "Backblaze B2",
    ],
    links: {
      demo: "https://www.thelivingfuneral.art/",
      github: "https://github.com/jasonli2004/TheLivingFuneral",
    },
  },
  {
    title: "Guess the Sketch",
    description:
      "An Android app combining creativity and AI recognition in a fun sketching game.",
    features: [
      "Interactive canvas for drawing",
      "AI-powered recognition",
      "Multiple difficulty levels",
    ],
    tech: ["Jetpack Compose", "Kotlin", "Vision AI"],
    links: {
      demo: "https://appetize.io/embed/b_ll3l6aehmudirl7dv7kyda2jii",
      github: "https://github.com/jasonli2004/GuessTheSketch",
    },
  },
  /*ChatGPT (GPT-4 Vision/Completion Models), ElevenLabs Text-to-Speech API, React, Next.js, Vercel, Backblaze B2.*/
  {
    title: "Lecture Flashcard Generator (In Progress)",
    description:
      "A web app designed to enhance study efficiency by transforming lecture notes or slides into concise flash memory cards using AI.",
    features: [
      "Upload lecture materials (images or PDFs)",
      "AI-powered summarization",
      "Streamlined workflow",
    ],
    tech: ["JavaScript", "Svelte", "Firebase", "GenAI"],
    links: {
      demo: "https://www.youtube.com/watch?v=5oBghd_5bHM",
      github: "https://github.com/jasonli2004/FlashCardGPT",
    },
  },
  {
    title: "Chick-Fil-A Diet Guide Website",
    description:
      "A website that provides nutritional information and food choice suggestions based on user preferences, enabling the users to make decisions according to their diet plans.",
    features: [
      "Upload lecture materials (images or PDFs)",
      "AI-powered summarization",
      "Streamlined workflow",
    ],
    tech: ["Flask", "PostgreSQL", "HTML"],
    links: {
      github:
        "https://github.com/jasonli2004/UndergradProjects/tree/main/Chick-fil-A_diet_guide_website",
    },
  },
  {
    title: "Portfolio Website",
    description:
      "This is the portfolio website you're currently browsing — fully designed and developed by me.",
    features: [
      "Upload lecture materials (images or PDFs)",
      "AI-powered summarization",
      "Streamlined workflow",
    ],
    tech: ["React", "JavaScript", "Vercel"],
    links: {
      github: "https://github.com/jasonli2004/portfolio",
    },
  },
];
